<script>

import { mapMutations, mapGetters } from "vuex";
import { loadScript } from "vue-plugin-load-script";
import axios from 'axios';
import { store } from '../store.js';

import { GoogleLogin } from "vue3-google-login";
export default {
  'name': 'LoginPage',
  data: () => {
    return {
      username: "",
      password: "",
      load: true,
      store,
      isLoading: false
    };
  },
  beforeCreate() {
    console.log("Before create");
  },
  beforeMount() {
    console.log("Mounting");
    window.st = this.st;
  },
  created() {
    console.log("Created");
    loadScript("https://accounts.google.com/gsi/client");
  },
  methods: {
    startSession(responseData) {
      console.log("Starting session");
      console.log(responseData);
      this.$cookies.set("pb_user", responseData.pbuser);
      this.$cookies.set("pb_token", responseData.pbtoken);
      this.store.logIn();
      console.log("Session started wqith user: " + responseData.user);
      console.log("Set cookies with user: " + this.$cookies.get("pb_user"));
    },
    async st(d) {
      this.isLoading = true;
      console.log("Callback");
      console.log(d);

      var data = {
        token: d.credential
      };
      try {
        const apiResponse = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/login`, JSON.stringify(data));
        console.log(`API Response: ${apiResponse.status}, ${apiResponse.data}, ${apiResponse.body}, ${apiResponse}`);
        console.log(apiResponse.status, apiResponse.data, apiResponse.body);
        if (apiResponse.status === 200) {
          const responseData = apiResponse.data;
          this.startSession(responseData);
          this.$router.push("/");
        } else {
          // Handle other status codes if needed
          prompt("Invalid Login!");
        }
      } catch (error) {
        console.error('Error:', error); // Log any errors
      } finally {
        this.isLoading = false;
      }
    },
    async login(e) {
    },
  },
};
</script>
<template>
  <div v-if="load" class="min-h-screen flex flex-col justify-center items-center p-6">
    <!-- Logo and Title Section -->
    <div class="text-center mb-8">
      <!-- You can replace this with your actual logo -->
      <div class="mx-auto items-center">
        <!-- Add the paperboi svg logo here -->
        <img src="favicon.svg" alt="Paperboi Logo" class="md:w-64 md:h-64 w-32 h-32 mx-auto">
      </div>
      <h1 class="text-4xl text-slate-200 mb-2">Paperboii</h1>
      <p class="text-white max-w-md">
        Your intelligent document management solution. Sign in to start organizing your papers effortlessly.
      </p>
    </div>

    <!-- Login Card -->
    <div class="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
      <div class="flex flex-col items-center">
        <div class="text-center mb-6">
          <h2 class="text-2xl font-semibold text-gray-700">Welcome Back</h2>
          <p class="text-gray-500 text-sm">Sign in to continue to Paperboiii</p>
        </div>
        <div class="flex justify-center w-full relative">
          <!-- Loading Overlay -->
          <div v-if="isLoading" class="absolute inset-0 flex items-center justify-center bg-white/80 rounded-lg z-10">
            <div class="flex items-center space-x-2">
              <div class="w-2 h-2 bg-purple-600 rounded-full animate-bounce"></div>
              <div class="w-2 h-2 bg-purple-600 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
              <div class="w-2 h-2 bg-purple-600 rounded-full animate-bounce" style="animation-delay: 0.4s"></div>
            </div>
          </div>
          <GoogleLogin
            :callback="st"
            prompt
            auto-login
            :disabled="isLoading"
            class="my-4 scale-125 transform" 
            :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
          />
        </div>
        
        <div class="text-center text-sm text-gray-500 mt-4">
          By signing in, you agree to our
          <a href="#" class="text-blue-600 hover:underline">Terms of Service</a> and
          <a href="#" class="text-blue-600 hover:underline">Privacy Policy</a>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-8 text-center text-sm text-gray-500">
      Need help? <a href="/contact" class="text-blue-600 hover:underline">Contact Support</a>
    </div>
  </div>
</template>
